import React from "react";
import { InterviewSidebarSection } from "../Components/InterviewSidebarSection";

export const InterviewSidebarSupplemental = ({ ...props }) => {
    return (
        <InterviewSidebarSection title="Supplemental Information" {...props}>
            <div className="row">Click here to navigate</div>
        </InterviewSidebarSection>
    );
};
